import { FormControlLabel } from '@mui/material';
import { styled } from '@mui/material/styles';

interface StyledSwitchProps {
  bold?: boolean;
}

// shouldForwardProp keeps `bold` from reaching FormControlLabel's underlying
// DOM node - MUI's styled() forwards unknown props to the wrapped component
// by default, and a boolean there would trigger React's "non-boolean
// attribute" warning (see StyledText.tsx for the same pattern).
const StyledSwitch = styled(FormControlLabel, {
  shouldForwardProp: prop => prop !== 'bold',
})<StyledSwitchProps>`
  margin: 0 !important;
  display: flex !important;
  align-items: center;
  gap: 0.75rem;

  & > div > span {
    font-family: var(--default-fonts);
  }

  & .MuiFormControlLabel-label {
    font-family: var(--default-fonts);
    font-size: 0.9375rem;
    line-height: 1.4;
    font-weight: ${({ bold }) => (bold ? '700 !important' : '400 !important')};
  }
`;

export default StyledSwitch;
